import { AspObject } from './AspObject';
import { TrackCoreObject } from './TrackCoreObject';
import * as settings from '../common/settings';
import { trackSymbols } from './TracksCorePool';
import { ObjectsDrawer } from './ObjectsDrawer';
import { IObjectsPool, IMapMngr } from './interfaces';
import { TrackCoreDataType, TrackDisplayCoreObject } from './TrackDisplayCoreObject';
import { DisplayObject } from './DisplayObject';
import * as enums from '../common/enums';
import * as consts from '../common/consts';
import * as msgs from '../../../app/msg/projMsgs';
import { AppInjector } from '../common/inject';
import { SideViewService } from '../side-view/side-view.service';
import { UserActionService } from '@core_n/user-action/user-action.service';

const trackTemplate =
  [
    { // 0 - DB main leader
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbMainLeader"
    },
    { // 1 - symbol
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 45, "height": 45 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "PlaneSymbol"
    },
    { // 2 - hook
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [1], // symbol
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0, "vertical": 0 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "HookCircle"
    },
    { // 3 - DB main area
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [0], // DB main leader
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0.5, "vertical": 0 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbMain"
    },
    { // 4 - track id
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [3], // DB main area
      "offset": { "x": 4, "y": 14 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": -0.5 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "CallSign"
    },
    { // 5 - altitude
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [3], // DB main area
      "offset": { "x": 18, "y": -6 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": 0.5 },
      "alignment": { "horizontal": 0.5, "vertical": -0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "Altitude"
    },
    { // 6 - DB aux leader
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [3], // DB main area
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0, "vertical": 0.5 },
      "alignment": { "horizontal": 0, "vertical": 0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbAuxLeader"
    },
    { // 7 - DB aux area
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [6], // DB aux leader
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0, "vertical": 0.5 },
      "alignment": { "horizontal": 0, "vertical": 0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbAux"
    },
    { // 8 - speed
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [7], // DB aux area
      "offset": { "x": 34, "y": 12 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": -0.5 },
      "alignment": { "horizontal": 0.5, "vertical": 0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "Speed"
    },
    { // 9 - heading
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [8], // speed
      "offset": { "x": 0, "y": 11 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": 0.5 },
      "alignment": { "horizontal": 0.5, "vertical": 0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "Heading"
    },
    { // 10 - aux text
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [0], // DB aux area
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": 0.5 },
      "alignment": { "horizontal": 0.5, "vertical": -0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "Heading"
    },
    { // 11 - aux text 2
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [10], // DB aux area
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": 1.3 },
      "alignment": { "horizontal": 0.5, "vertical": -0.5 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "Heading"
    },
    { // 12 - Lost Indiactor
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 30 },
      "minSize": { "width": 45, "height": 45 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "PlaneSymbol"
    },
    { // 13 - external track symbol(pic)
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 45, "height": 45 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "PlaneSymbol"
    },
  ];

const sensorTrackTemplate =
  [
    { // 0 - DB main leader
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbMainLeader"
    },
    { // 1 - symbol
      "isDrawItem": true,
      "isSpecific": true,
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 45, "height": 45 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "PlaneSymbol"
    },
    { // 2 - hook
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [1],
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0, "vertical": 0 },
      "alignment": { "horizontal": 0, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "HookCircle"
    },
    { // 3 - DB main area
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [0],
      "offset": { "x": 0, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": 0.5, "vertical": 0 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "DbMain"
    },
    { // 4 - track Id
      "isDrawItem": true,
      "isSpecific": false,
      "relatedToIndex": [3],
      "offset": { "x": 4, "y": 0 },
      "minSize": { "width": 0, "height": 0 },
      "relatedAlignment": { "horizontal": -0.5, "vertical": 0 },
      "alignment": { "horizontal": 0.5, "vertical": 0 },
      "pad": { "width": 0, "height": 0 },
      "trimSize": { "width": 0, "height": 0 },
      "name": "CallSign"
    },
  ];

const miscSymbolNames = [
  'hook-circle',
  'track-db-alert-bg',
  'track-db-main-bg',
  'track-db-main-bg-small',
  'track-db-aux-bg',
  'track-db-aux-bg-small',
  'track-db-alert-icon',
  'track-db-lock-icon',
  'track-db-horiz-leader',
  'track-db-vert-leader',
  'track-popup-menu',
  'extracksym',
];

const models3D: Array<any> = [
  {
    key: 'jet',
    model: 'Aircraft-jet/jetanima.obj',
    material: 'Aircraft-jet/jetanima.mtl',
    scale: 1
  },
  {
    key: 'airplane',
    model: 'Aircraft-Airplane_v1/11803_Airplane_v1_l1.obj',
    material: 'Aircraft-Airplane_v1/11803_Airplane_v1_l1.mtl',
    scale: 1
  },
  {
    key: 'drone',
    model: 'Aircraft-drone/drone.obj',
    scale: 1
  },
];

const imagesToLoad = ObjectsDrawer.initImagesToLoad(miscSymbolNames, Array.from(trackSymbols.values()));

const drawFlags = [ // elements per template
  { scale: 100000, flags: [true, true, true, true, true, true, true, true, true, true, true, true, true, true] },
  { scale: 2000000, flags: [true, true, true, true, true, true, true, true, true, true, true, true, true, true] },
  { scale: Number.MAX_VALUE, flags: [false, true, true, false, false, false, false, false, false, false, true, true, true, true] }
];

const itemsProperties = [ // elements per template
  null, // horiz DB leader
  NeWMI.Draw.DrawMgr.Enums.EProperties.EORotation | NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor,
  null, null, null, null,
  null, // vert DB leader
  null, null, null,
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOSize,
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor | NeWMI.Draw.DrawMgr.Enums.EProperties.EOSize,
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor,
  NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor
];

export class TracksCoreDrawer extends ObjectsDrawer {

  constructor(mapMngr: IMapMngr, objectsPool: IObjectsPool, parentLayer) {
    super(mapMngr, objectsPool, settings.DisplayFilter.Tracks, parentLayer, trackTemplate,
      imagesToLoad, drawFlags, itemsProperties /* newmi-tbd , undefined, models3D*/);

    this.addToDmPeriodic = true;

    this.dataKeys.push(TrackCoreDataType.Trail, TrackCoreDataType.Vector + 1, TrackCoreDataType.Vector);
    this.typeKeys.push(TrackCoreDataType.Trail, TrackCoreDataType.Vector + 1, TrackCoreDataType.Vector);

    // Add callback for TrackSourceHidden event
    settings.eventsEmitter.on('TrackSourceHidden', function (sensorID: number) {
      this.handleSourceHidden(sensorID);
    }.bind(this));

    // Add callback for TrackSourceShown event
    settings.eventsEmitter.on('TrackSourceShown', function (sensorID: number) {
      this.handleSourceShown(sensorID);
    }.bind(this));

    // Add callback for TrackIdentityToggled event
    settings.eventsEmitter.on('TrackIdentityToggled', function (trackIdent: enums.Hostility) {
      this.handleTrackIdentityToggled(trackIdent);
    }.bind(this));
  }

  protected templateStyles(images): any[] {
    let imageStyle = new NeWMI.Draw.Styles.ImagesFontStyle({ images: images });
    // elements per template
    return [imageStyle, imageStyle, imageStyle, imageStyle,
      this.smallTextStyle, this.smallTextStyle, imageStyle,
      imageStyle, this.smallTextStyle, this.smallTextStyle,
      this.smallTextStyle, this.smallTextStyle, this.smallTextStyle, imageStyle];
  }

  isLayerVisible(): boolean {
    return settings.userSettings.filterOn[this.filterType];
  }

  protected addDrawTypes(images) {
    let lineProps = { properties: NeWMI.Draw.DrawMgr.Enums.EProperties.EOColor };
    this.addGeometryDrawType(TrackCoreDataType.Trail, lineProps);
    this.addGeometryDrawType(TrackCoreDataType.Vector + 1, lineProps);
    this.addGeometryDrawType(TrackCoreDataType.Vector, lineProps);
    super.addDrawTypes(images);
  }

  protected allImagesLoaded(images) {
    let size = 45;

    images['hook-circle'].size = { width: size + 10, height: size + 10 };
    images['extracksym'].size = { width: 10, height: 10 };
    images['fighter-plane'].size = {width: 20, height: 20};

    let trackImages = Array.from(trackSymbols.values());
    for (let image of Object.keys(images)) {
      let factor = 0.7;
      if (trackImages.includes(image)) {
        factor = 0.7;
        if (image == 'missile-weapon' || image == 'fighter-plane') {
          factor = 1;
        }
        images[image].size = { width: size * factor, height: size * factor };
      }
    }
    super.allImagesLoaded(images);
  }

  // Periodic refresh
  periodicUpdate(): boolean {
    if (this.drawMgr && this.objectsLayerVisible) {
      let trailsDisplayed =
        settings.userSettings.trackElementsOn[consts.TRACK_DISPLAY_ELEMENT_HISTORY];
      let vectorsDisplayed = settings.userSettings.sysTrackElementsOn[consts.SYS_TRACK_DISPLAY_ELEMENT_VECTOR];

      if (this.drawMgr.typesVisualProps[TrackCoreDataType.Vector])
        this.drawMgr.typesVisualProps[TrackCoreDataType.Vector].visible = vectorsDisplayed;
      if (this.drawMgr.typesVisualProps[TrackCoreDataType.Vector + 1])
        this.drawMgr.typesVisualProps[TrackCoreDataType.Vector + 1].visible = vectorsDisplayed;
      if (this.drawMgr.typesVisualProps[TrackCoreDataType.Trail])
        this.drawMgr.typesVisualProps[TrackCoreDataType.Trail].visible = trailsDisplayed;
    }

    return super.periodicUpdate();
  }

  protected handleSourceHidden(sensorID: number) {
    //console.debug('Tracks source hidden for sensor', sensorID);
    this.allObjects.forEach((track: TrackDisplayCoreObject) => {
      if (track.systemID == sensorID && !track.isVisible()) {
        this.removeObjectFromDm(track);
      }
    });
  }

  protected handleSourceShown(sensorID: number) {
    //console.debug('Tracks source shown for sensor', sensorID);
    this.allObjects.forEach((track: TrackDisplayCoreObject) => {
      if (track.systemID == sensorID && track.isVisible()) {
        this.addObjectToDm(track);
      }
    });
  }

  protected handleTrackIdentityToggled(trackIdent: number) {
    //console.debug('Tracks identity', trackIdent, 'toggled');
    this.allObjects.forEach((track: TrackDisplayCoreObject) => {
      if (trackIdent == -1 && track.isVisible()) {
        this.addObjectToDm(track);
      }
      else if (trackIdent == -2) {
        this.removeObjectFromDm(track);
      }
      else if ((track.getAspObject() as TrackCoreObject).hostility == trackIdent) {
        if (track.isVisible())
          this.addObjectToDm(track);
        else
          this.removeObjectFromDm(track);
      }
    });
  }

  // Override ObjectsDrawer
  createDisplayObject(obj: AspObject): DisplayObject {
    return new TrackDisplayCoreObject(obj, this);
  }

  // Override ObjectsDrawer
  handleUserAction(action: number, obj: AspObject): boolean {
    if (action != consts.USER_ACTION_HISTORY && action != consts.USER_ACTION_DYNAMIC_CENTER && action != consts.USER_ACTION_SIDE_VIEW && action != consts.USER_ACTION_FORCE_SEND_POLY)
      return false;

    let dispObj: DisplayObject = this.getObject(obj.id);
    if (!dispObj)
      return false;

    if (action == consts.USER_ACTION_HISTORY) {
      // Toggle trail visibility
      obj.setTrailVisibility(!obj.isTrailVisible());
      return true;
    }
    else if (action == consts.USER_ACTION_DYNAMIC_CENTER) {
      // Toggle dynamic center
      if (this.mapMngr.getDynamicCenterId() == obj.id)
        this.mapMngr.setDynamicCenterId(null);
      else
        this.mapMngr.setDynamicCenterId(obj.id);
      return true;
    }
    else if (action == consts.USER_ACTION_SIDE_VIEW) {
      // Create side view
      AppInjector.get(SideViewService).showSideView(obj as TrackCoreObject);
    }
    else if (action == consts.USER_ACTION_FORCE_SEND_POLY) {
      // Send New SWA to send the polygon to smart...
      // let ForceSend = new msgs.ForceSendToSmart();
      // ForceSend.TrackNumber = (obj as TrackCoreObject).trackID;
      // AppInjector.get(UserActionService).sendUserAction(ForceSend);
    }
    return false;
  }

  // Override ObjectsDrawer
  getOpacity(): number {
    return settings.userSettings.trackOpacity;
  }

}
